import React, { useState, useEffect } from 'react';
import { aboutBg, services51 } from '../../../../assets/images'; // Örnek görsel eklendi
import { useTranslation } from 'react-i18next';
import SubOtherHero from '../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero';

const Drillbits = () => {
  const { t } = useTranslation();

  const [heroHeight, setHeroHeight] = useState('300px');

  useEffect(() => {
    const updateHeight = () => {
      setHeroHeight(window.innerWidth < 640 ? '200px' : '300px');
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div
        className="relative bg-black/60 w-full"
        style={{
          backgroundImage: `url(${aboutBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: heroHeight,
        }}
      > 
        <SubOtherHero title="Drill bits (PDC/RC)"  />
      </div>

      {/* Content Section */}
      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="md:max-w-container max-w-containerSm mx-auto md:flex md:items-start md:justify-between gap-10">
          {/* Left Content */}
            <div className="md:w-1/2">
                    
             <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t('Drill bits (PDC/RC)')}
            </p>
          
           <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                        {t('Caspian Rock Solutions provides both the supply of drill bits (PDC and RC) and rental services on a meter rate. Given alternative and unique solution is being provided to you on your project.')}
                      </p>
                      <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                        <li>{t('PDC DRILL BITS: being produced in a wide variety of diameters and modifications. They are used for drilling of vertical, S-shaped, directional and complex wells.')}</li>
                        <li>{t('RC DRILL BITS: they are used in various drilling conditions, both for drilling offshore wells and for drilling wells on land (solid rock, frequent alternation of layers, high content of silication, high degree of abrasiveness and intensity of dogleg severity).')}</li>
                        <li>{t('SUPPORT SERVICES: experienced personnel, the rental rate of the bits per meter. All drill bits correspond to the international standards of IADC.')}</li>
                      </ul>
          
                    </div>
          

          {/* Right Image */}
          <div className="mt-8 md:mt-0 md:w-1/2">
            <img src={services51} alt="Service Illustration" className="w-full rounded-lg shadow-md" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Drillbits;
